import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { ArrowRight, Clock, Loader2 } from "lucide-react";

const Blog = () => {
  const [posts, setPosts] = useState(null);

  useEffect(() => {
    api.get("/posts").then(({ data }) => setPosts(data)).catch(() => setPosts([]));
  }, []);

  return (
    <div data-testid="blog-page">
      <section className="border-b border-border bg-muted">
        <div className="container-wide py-16 lg:py-20">
          <p className="kicker">The Fast Junk Pros Journal</p>
          <h1 className="mt-3 font-display text-4xl font-black sm:text-5xl lg:text-6xl">
            Hauling advice, pricing guides, <br /> and homeowner playbooks.
          </h1>
          <p className="mt-4 max-w-2xl text-lg text-muted-foreground">
            Real answers to the questions we get every day — from junk removal pricing to storm cleanup checklists.
          </p>
        </div>
      </section>

      <section className="section">
        <div className="container-wide">
          {posts === null ? (
            <div className="flex items-center justify-center py-20 text-muted-foreground">
              <Loader2 className="h-6 w-6 animate-spin" />
            </div>
          ) : posts.length === 0 ? (
            <div className="rounded-sm border border-border bg-card p-10 text-center text-muted-foreground">
              No articles yet — check back soon.
            </div>
          ) : (
            <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
              {posts.map((p) => (
                <Link
                  key={p.slug}
                  to={`/blog/${p.slug}`}
                  className="group flex flex-col rounded-sm border border-border bg-card p-6 transition-colors hover:border-primary"
                  data-testid={`post-card-${p.slug}`}
                >
                  <div className="flex items-center gap-2 text-xs uppercase tracking-wider text-muted-foreground">
                    <Clock className="h-3.5 w-3.5" /> {p.read_minutes} min read
                  </div>
                  <h2 className="mt-4 font-display text-xl font-black leading-tight group-hover:text-primary">
                    {p.title}
                  </h2>
                  <p className="mt-3 text-sm text-muted-foreground">{p.excerpt}</p>
                  <span className="mt-6 inline-flex items-center gap-1 text-sm font-semibold text-primary">
                    Read article <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
                  </span>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default Blog;
